const recaptcha = $('#js-g-recaptcha');
const cbError = $('.cb-error-message');
const recaptchaFeedback = $('.js-g-recaptcha-feedback');

function init() {
    var recaptchaRef;

    this.reCaptchaSuccess = false;
    const verifyCallback = () => {
        this.reCaptchaSuccess = true;
        recaptchaFeedback.hide();
    };
    const expiredCallback = () => {
        setTimeout(() => {
            window.grecaptcha.reset();
            this.reCaptchaSuccess = false;
        }, 0); // adds recaptcha reset to the end of queue
    };
    window.onloadCallback = function () {
        if (recaptcha.length > 0 && recaptcha.html() === '') {
            recaptchaRef = window.grecaptcha.render(recaptcha[0], {
                sitekey: recaptcha.data('sitekey'),
                callback: verifyCallback,
                'expired-callback': expiredCallback
            });

            recaptcha.data('recaptcha-ref', recaptchaRef);
        }
    };

    cbError.hide();
    recaptchaFeedback.hide();
    const locale = $('.js-locale').data('locale').replace('_', '-');
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', '//www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=' + locale);
    document.getElementsByTagName('body')[0].appendChild(scriptTag);
}

function modalInit() {
    let modalRecaptcha = $('#js-login-modal').find('#js-g-recaptcha');

    this.reCaptchaSuccess = false;
    const verifyCallback = () => {
        this.reCaptchaSuccess = true;
        $('.js-g-recaptcha-feedback').hide();
    };
    const expiredCallback = () => {
        setTimeout(() => {
            window.grecaptcha.reset();
            this.reCaptchaSuccess = false;
        }, 0);
    };

    if (modalRecaptcha.html() === '') {
        let recaptchaRef = window.grecaptcha.render(modalRecaptcha[0], {
            sitekey: modalRecaptcha.data('sitekey'),
            callback: verifyCallback,
            'expired-callback': expiredCallback
        });

        modalRecaptcha.data('recaptcha-ref', recaptchaRef);
    }

    cbError.hide();
    $('.js-g-recaptcha-feedback').hide();
    const locale = $('.js-locale').data('locale').replace('_', '-');
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', '//www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=' + locale);
    document.getElementsByTagName('body')[0].appendChild(scriptTag);
}

function checkReCaptchaStatus() {
    $('.js-g-recaptcha-feedback').hide();
    if (!this.reCaptchaSuccess) {
        $('.js-g-recaptcha-feedback').show();
        return false;
    }
    return true;
}

function cleanErrorMessage() {
    $('.cb-error-message-text').text('');
    $('.cb-error-message').hide();
}

function isCaptchaEnable() {
    return $('#js-g-recaptcha').first().data('enable') === true;
}

function isModalCaptchaEnable() {
    return $('#js-login-modal').find('#js-g-recaptcha').data('enable') === true;
}

function resetCaptcha() {
    if (window.grecaptcha) {
        if (recaptcha.length > 0) {
            window.grecaptcha.reset(recaptcha.data('recaptcha-ref'));
        }
    }
}

module.exports = {
    init: init,
    modalInit: modalInit,
    checkReCaptchaStatus: checkReCaptchaStatus,
    cleanErrorMessage: cleanErrorMessage,
    isCaptchaEnable: isCaptchaEnable,
    isModalCaptchaEnable: isModalCaptchaEnable,
    resetCaptcha: resetCaptcha
};
